"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SingleValue;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("../../Typography"));
/* eslint react/prop-types: 0 */

function SingleValue(_ref) {
  var selectProps = _ref.selectProps,
    innerProps = _ref.innerProps,
    children = _ref.children;
  var showAdornmentStyle = selectProps.textFieldAdornment && selectProps.isSearchable;
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(selectProps.classes.singleValue, (0, _defineProperty2["default"])({}, selectProps.classes.singleValueWithAdornment, showAdornmentStyle)),
    "data-metrics": selectProps.dataMetrics.singleValue,
    variant: "body1"
  }, innerProps), children);
}